import { render, staticRenderFns } from "./RequestNumberConfirmationBox.vue?vue&type=template&id=71343988&scoped=true&"
import script from "./RequestNumberConfirmationBox.vue?vue&type=script&lang=ts&"
export * from "./RequestNumberConfirmationBox.vue?vue&type=script&lang=ts&"
import style0 from "./RequestNumberConfirmationBox.vue?vue&type=style&index=0&id=71343988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71343988",
  null
  
)

export default component.exports